'use client';

import { InstantSearchNext } from 'react-instantsearch-nextjs';
import { useConnector } from 'react-instantsearch';
import connectAutocomplete, { type AutocompleteConnectorParams } from 'instantsearch.js/es/connectors/autocomplete/connectAutocomplete';
import { algoliasearch } from 'algoliasearch';
import type { PropsWithChildren } from 'react';

export const searchClient = algoliasearch(
	process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? process.env.STORYBOOK_ALGOLIA_APP_ID!,
	process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY ?? process.env.STORYBOOK_ALGOLIA_SEARCH_KEY!,
);

// Connect the InstantSearch.js `connectAutocomplete` connector to your component
export function useAutocomplete(props?: AutocompleteConnectorParams) {
	// @ts-ignore
	return useConnector<AutocompleteConnectorParams, AutocompleteWidgetDescription>(connectAutocomplete, props);
}
export function AlgoliaSearch(props: PropsWithChildren & { indexName?: string }) {
	return (
		<InstantSearchNext indexName={props.indexName ?? 'data'} searchClient={searchClient}>
			{props.children}
		</InstantSearchNext>
	);
}
